import { START_LOADING, END_LOADING } from "./loading_actions";
import { postRegister } from "../../utils/api";
import { TITLE_ERROR, TITLE_NOTIFICATION, TEXT_REGISTER_SUCCESS } from "../../utils/constants";
import { SET_PORTAL_API } from "./portal_actions";


export const EDIT_FIRST_NAME_REGISTER = 'EDIT_FIRST_NAME_REGISTER';
export const EDIT_LAST_NAME_REGISTER = 'EDIT_LAST_NAME_REGISTER';
export const EDIT_SURNAME_REGISTER = 'EDIT_SURNAME_REGISTER';
export const EDIT_PHONE_REGISTER = 'EDIT_PHONE_REGISTER';
export const EDIT_EMAIL_REGISTER = 'EDIT_EMAIL_REGISTER';
export const EDIT_FIRST_PASSWORD = 'EDIT_FIRST_PASSWORD';
export const EDIT_SECOND_PASSWORD = 'EDIT_SECOND_PASSWORD';
export const RESET_REGISTER_FORM = 'RESET_REGISTER_FORM';
export const SWITCH_CHECKBOX_PERMISSION = 'SWITCH_CHECKBOX_PERMISSION';


export const postRegisterThunk = (first_name, last_name, surname, phone, email, first_password, navigate) => {
  return function (dispatch) {
    dispatch({ type: START_LOADING });

    postRegister(first_name, last_name, surname, phone, email, first_password)
        .then(data => {
          dispatch({ type: RESET_REGISTER_FORM });
          navigate('/', {replace: true});
          dispatch({
            type: SET_PORTAL_API,
            title: TITLE_NOTIFICATION,
            text: TEXT_REGISTER_SUCCESS
          });
        })
        .catch(error => {
          console.log('error =', error);
          dispatch({
            type: SET_PORTAL_API,
            title: TITLE_ERROR,
            text: Object.values(error)
          });
        })
        .finally(() => {
          dispatch({ type: END_LOADING });
        });
  }
}
